import { render, staticRenderFns } from "./layoutSidenav_nav.vue?vue&type=template&id=3189e98e&scoped=true&"
import script from "./layoutSidenav_nav.vue?vue&type=script&lang=js&"
export * from "./layoutSidenav_nav.vue?vue&type=script&lang=js&"
import style0 from "./layoutSidenav_nav.vue?vue&type=style&index=0&id=3189e98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189e98e",
  null
  
)

export default component.exports